import { ComponentType } from 'react';
import { flushSync, render } from 'react-dom';

import { IForm } from 'modules/forms/interfaces/form.interfaces';

export const composeFormHTML = (
  content?: string,
  signatureBase64?: string,
  signatureName?: string,
): string => {
  const signatureSection = signatureBase64
    ? `
    <div class="form-input-block">
      <h3 class="form-input-block__title">Patient/Guardian Signature</h3>
      <div class="form-group">
        ${
          signatureBase64
            ? `<div class="signature-container" style="margin-bottom: 16px;">
            <img src="${signatureBase64}" 
                 alt="Signature" 
                 style="max-width: 100%; height: auto;" />
          </div>`
            : ''
        }
        ${
          signatureName
            ? `<div class="signature-name" style="margin-top: 8px;">
            <strong>${signatureName}</strong>
          </div>`
            : ''
        }
      </div>
    </div>
  `
    : '';

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Form</title>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&amp;display=swap" rel="stylesheet">
    </head>
    <body>
    <style>
       .form-badge-content,.form-input-block__description,.form-result-block__title{line-height:22px}body{font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";font-size:14px;font-weight:400;line-height:1.43;color:#0a2f5a}.form-check{display:block;padding-left:24px;margin-bottom:2px}.form-check .form-check-input{float:left;margin-left:-24px}.form-check-input{border:1px solid #9caec4;background-color:#fff;background-repeat:no-repeat;background-position:center;background-size:contain;vertical-align:top;appearance:none;print-color-adjust:exact;margin-top:2px;width:16px;height:16px}.form-check-input[type=checkbox]{border-radius:2px}.form-check-input[type=radio]{border-radius:50%}.form-check-input[type=checkbox]:checked{background-color:$primary;border-color:$primary;background-image:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><path fill='white' d='M12.579 23.686l-6.933-6.973c-0.417-0.419-0.417-1.098 0-1.517l1.508-1.517c0.417-0.419 1.092-0.419 1.508 0l4.671 4.697 10.004-10.061c0.417-0.419 1.092-0.419 1.509 0l1.508 1.517c0.417 0.419 0.417 1.098 0 1.517l-12.267 12.337c-0.417 0.419-1.092 0.419-1.509-0z' /></svg>")}.form-check-input[type=radio]:checked{background-color:$primary;border-color:$primary;background-image:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2.5' fill='white'/></svg>")}.form-input-block-inner,.form-paragraph{max-width:840px}.form-badge{padding:8px 14px;display:flex;align-items:flex-start;gap:8px}.form-badge .icons{margin-top:2px;margin-right:0;width:18px;height:18px;min-width:18px;font-size:16px}.form-badge-content{max-width:960px;font-size:14px;white-space:normal;text-align:left;letter-spacing:-.24px}.form-badge__title{font-weight:600}.form-badge__description{margin-top:4px;padding-bottom:16px;color:#9caec4}.form-result-block{padding:24px;display:flex;flex-direction:column;align-items:center;text-align:center;background-color:#f4f5f9}.form-input-block__title,.form-result-block__title{padding-bottom:16px;font-size:16px;font-weight:600}.form-result-block__description{max-width:700px;font-size:16px;line-height:22px}.form-result-block__logo{margin-top:40px;max-width:120px;height:30px}.form-result-block__logo img{display:block;object-fit:contain;width:100%}.form-input-block{margin:16px 0;padding:16px;background-color:#f4f5f9}.form-input-block__title{margin:0}.form-input-block ul{margin:0;padding-left:16px}.form-input-block .form-group .form-check{margin-top:14px}
    </style>
    <div>${content || ''}</div>
    ${signatureSection}
    </body>
    </html>
  `;
};

export const getFormResultHTML = (
  form: IForm,
  FormResult: ComponentType<{ form: IForm }>,
  signatureBase64?: string,
  signatureName?: string,
): string => {
  const primaryColor = document.documentElement.style.getPropertyValue('--primary');
  const div = document.createElement('div');
  flushSync(() => {
    render(<FormResult form={form} />, div);
  });

  return composeFormHTML(div.innerHTML, signatureBase64, signatureName)
    .replace(/\$primary/g, primaryColor)
    .replace(/>\s+</g, '><')
    .trim();
};
